/* eslint-disable no-param-reassign, no-console */
import { consoleEvents } from '@pb/utils'

const dispatchableQueue = []

export const triggerDispatchOfQueue = (dispatch): any => {
  if (dispatchableQueue.length) {
    consoleEvents.info('triggerDispatchOfQueue started')
    dispatchableQueue.forEach((queueItem) => dispatch(queueItem))
  }
}

export default triggerDispatchOfQueue
